import React, { useEffect, useState } from 'react';
import { GoStar } from 'react-icons/go';
import { Form, Spinner, Table } from 'react-bootstrap';
import { HiOutlineChartBar, HiOutlineUsers } from 'react-icons/hi2';
import { CgArrowRight } from 'react-icons/cg';
import { useGetAssignedTicketCountQuery, useGetAssignedTicketQuery } from 'api/requestApi';
import { AssignedStatisticsCount, AssignedStatusDetails } from 'model/request-model';
import { useGetUsersQuery } from 'api/userManagementApi';
import { ItemModel } from 'model/users-model';
import { showToastError } from 'components/toastify/ToastNotifications';
import { FormattedDateOnly } from 'components/formatted-date';

type Props = {
}

const ReportStatistics = (props: Props) => {

    const [loading, setLoading] = useState(false);
    const [showAssignedTable, setShowAssignedTable] = useState(false);

    const [assignedStatusDetails, setAssignedStatusDetails] = useState<AssignedStatusDetails[]>();
    const [assignedStatus, setAssignedStatus] = useState('');

    const [selectedUser, setSelectedUser] = useState<string>('');
    const [adminUsers, setAdminUsers] = useState<ItemModel>();    
    const [assignedTicketCountPerUser, setAssignedTicketCountPerUser] = useState<AssignedStatisticsCount>();

    const { data: usersData, error: usersError, isFetching: usersIsFetching, refetch: refetchUser } = useGetUsersQuery();
    useEffect(() => {
        if (usersIsFetching) {
            setLoading(true);
        }
        else {
            setLoading(false);
            if (usersError) {
                showToastError('Unable to fetch data from the server');
            }
            else {
                setAdminUsers(usersData?.data as ItemModel);
            }
        }
    }, [usersIsFetching]);

    const { data: assignedTicketCount, error: assignedTicketCountError, isFetching: assignedTicketCountIsFetching } = useGetAssignedTicketCountQuery(selectedUser, { skip: selectedUser.length === 0 });

    useEffect(() => {
        if (assignedTicketCountIsFetching) {
            setLoading(true);
        }
        else {
            setLoading(false);
            if (assignedTicketCountError) {
                showToastError('Unable to fetch data from the server');
            }
            else {
                setAssignedTicketCountPerUser(assignedTicketCount?.data as AssignedStatisticsCount);
            }
        }             
        setShowAssignedTable(false);
    }, [assignedTicketCountIsFetching, selectedUser]);

    const { data: assignedStatusData, error: assignedStatusDataError, isFetching: assignedStatusDataIsFetching } = useGetAssignedTicketQuery([selectedUser, assignedStatus], { skip: assignedStatus.length === 0 });

    useEffect(() => {
            if (assignedStatusDataIsFetching) {
                setLoading(true);
            }
            else {
                setLoading(false);
                setAssignedStatusDetails(assignedStatusData?.data as AssignedStatusDetails[]);
            }
    }, [assignedStatusDataIsFetching, assignedStatus]);

    const handleShowAssignedTable = (data: string) => {
        setShowAssignedTable(true);
        setAssignedStatus(data);
    }

    return (
        <div>
            {loading ? <div className='text-center p-5'><Spinner /></div> : <div className='row'>
                <div className='col-lg-4'>
                    <Form.Select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)} aria-label="Floating label select example" className="input-field w-100">
                        <option value=''>Select Sub Admin</option>
                        {adminUsers?.items?.map((user, key) => <option value={user?.userId}>{`${user?.firstName} ${user?.lastName}`}</option>)}
                    </Form.Select>
                </div>
                {assignedTicketCountPerUser && <div className='col-lg-12 row py-4'>
                    <div className='col-lg-4 p-2'>
                        <div className='card-button d-flex gap-3'>
                            <HiOutlineUsers size={40} className='primary-text my-auto' />
                            <p className='d-flex justify-content-between m-0'><span className='font-size-sm text-dark'>Total Assigned Tickets <br /><h3 className='fw-bold m-0'>{assignedTicketCountPerUser?.totalAssigned}</h3></span>
                            <span onClick={() => handleShowAssignedTable('ASSIGNED')} className='view-all pointer mt-auto ms-auto primary-text font-size-sm'>View all <CgArrowRight /></span></p>
                        </div>
                    </div>

                    {/* <div className='col-lg-4 p-2'>
                        <div className='card-button d-flex gap-3'>
                            <HiOutlineUsers size={40} className='primary-text my-auto' />
                            <p className='d-flex justify-content-between m-0'><span className='font-size-sm text-dark'>Pending Tickets <br /><h3 className='fw-bold m-0'>{assignedTicketCountPerUser?.assignedCount}</h3></span>
                            <span onClick={() => handleShowAssignedTable('PENDING')} className='view-all pointer mt-auto ms-auto primary-text font-size-sm'>View all <CgArrowRight /></span></p>
                        </div>
                    </div> */}

                    <div className='col-lg-4 p-2'>
                        <div className='card-button d-flex gap-3'>
                            <HiOutlineUsers size={40} className='primary-text my-auto' />
                            <p className='d-flex justify-content-between m-0'><span className='font-size-sm text-dark'>Resolved Tickets <br /><h3 className='fw-bold m-0'>{assignedTicketCountPerUser?.resolvedCount}</h3></span>
                            <span onClick={() => handleShowAssignedTable('RESOLVED')} className='view-all pointer mt-auto ms-auto primary-text font-size-sm'>View all <CgArrowRight /></span></p>
                        </div>
                    </div>
                </div>}

                {showAssignedTable && <div className='col-lg-12'>
                    {assignedStatusDetails && assignedStatusDetails?.length > 0 ? <Table responsive className='table'>
                        <thead>
                            <tr>
                                <th></th>
                                <th><HiOutlineChartBar className='primary-text' />
                                <label className='table-filter fw-normal font-size-sm border-0 w-auto py-2'>Priority</label>
                                </th>
                                <th>
                                    <label className='table-filter fw-normal font-size-sm border-0 w-auto py-2'>Category</label>
                                </th>
                                <th></th>
                                <th className=''>
                                    <label className='table-filter fw-normal font-size-sm border-0 w-auto py-2'>Status</label>
                                </th>
                                <th className='text-center'>
                                    <label className='table-filter fw-normal font-size-sm border-0 w-auto py-2'>Date</label>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {assignedStatusDetails && assignedStatusDetails?.map((item, key) => <tr key={key} className='align-middle'>
                                <td><GoStar className='d-inline' /></td>
                                <td className='lh-base'><span className='fw-bold font-size-sm'>{item?.customerName}</span><br /><span className='font-size-smm text-secondary'>{item?.customerEmail}</span></td>
                                <td><span className='dot bg-green me-1'></span><span className='font-size-sm'>{item?.categoryName}</span></td>
                                <td className='lh-base'><span className='fw-bold font-size-sm'>{item?.subject}</span></td>
                                <td><button type='button' className={`btn font-size-sm ${item?.status === 'PENDING' ? 'btn-secondary' : item?.status === 'ASSIGNED' ? 'btn-success' : item?.status === 'RESOLVED' ? 'btn-primary' : 'btn-danger'} btn-sm font-size-smm rounded-3 py-1`}>{item?.status}</button></td>
                                <td className='text-center'>{FormattedDateOnly(item?.createdAt)}</td>
                            </tr>)}
                        </tbody>
                    </Table> :
                    <div className='text-center p-5 fs-4'>No data available</div>}
                </div>}
            </div>}
        </div>
    )
}

export default ReportStatistics;